export const apiName: string = 'locais-abastecimentos';
export const locaisRoute: string = 'locais';
export const locaisStorage: string = 'locais';
export const locaisModuleName: any = {plural: 'Locais', single: 'Local'};

export const locaisCombustiveisApiName: string = 'combustiveis-locais-abastecimentos';

export const TiposLocais = [
    {Key: 2, Value: 'Convênio'},
    {Key: 1, Value: 'Interno'}
];

export const locaisQuery: any = {
    "where":{
        "ativo":true,
        "nome":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"nome"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/shared/data.service.ts
 **/